import type { PluginObject } from 'vue'
import { ref } from 'vue'

const LoadingPlugin: PluginObject<never> = {
  install(Vue) {
    const loading = ref(false)
    Vue.prototype.$loading = loading
  },
}

export default LoadingPlugin
